import Router from "./Router";

// import * as Sentry from "@sentry/react";

// Sentry.init({
// 	dsn: "https://0c750fbcf2684a13ba66d0c62e1031d4@o4505701669470208.ingest.sentry.io/4505398196764672",
// 	tracesSampleRate: 0.5,
// 	// ...
// 	// Note: if you want to override the automatic release value, do not set a
// 	// `release` value here - use the environment variable `SENTRY_RELEASE`, so
// 	// that it will also get attached to your source maps
// });

const App = () => {
	return <Router />;
};

export default App;
